/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plantabinvoices2Inputs */

const en_plantabinvoices2 = /** @type {(inputs: Plantabinvoices2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices`)
};

const de_plantabinvoices2 = /** @type {(inputs: Plantabinvoices2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungen`)
};

/**
* | output |
* | --- |
* | "Invoices" |
*
* @param {Plantabinvoices2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plantabinvoices2 = /** @type {((inputs?: Plantabinvoices2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plantabinvoices2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plantabinvoices2(inputs)
	return de_plantabinvoices2(inputs)
});
export { plantabinvoices2 as "planTabInvoices" }